import { APIWorkspaceOverview, ArdoqId } from '@ardoq/api-types';
import { actionCreator } from '@ardoq/rxbeach';

export const requestDeletion = actionCreator<ArdoqId[]>(
  '[workspaces] REQUEST_DELETION'
);

export const cancelDeletion = actionCreator('[workspaces] CANCEL_DELETION');

export const deleteSelectedWorkspaces = actionCreator<ArdoqId[]>(
  '[workspaces] DELETE_SELECTED_WORKSPACES'
);

export const websocketFakerDeletedWorkspaces = actionCreator<ArdoqId[]>(
  '[workspaces] WEBSOCKET_FAKER_DELETED_WORKSPACES'
);

export const clearSelectedCheckboxes = actionCreator(
  '[workspaces] CLEAR_SELECTED_CHECKBOXES'
);

export const workspacesOverviewRefetched = actionCreator<
  APIWorkspaceOverview[]
>('[workspaces] WORKSPACES_OVERVIEW_REFETCHED');

export const toggleSelectedIds = actionCreator<ArdoqId[]>(
  '[workspaces] TOGGLE_SELECTED_IDS'
);

export const recalculateWorkspaceField = actionCreator<{
  fieldId: ArdoqId;
  branchId?: ArdoqId | null;
}>('[workspaces] RECALCULATE_WORKSPACE_FIELD');
